<div class="auth-callback">
  <p *ngIf="!errored()" class="status">{{ message() }}</p>

  <ng-container *ngIf="errored()">
    <p class="error-message">{{ message() }}</p>
    <a mat-raised-button color="primary" routerLink="/login">Back to login</a>
  </ng-container>
</div>
